export default "__VITE_ASSET__ChLXUQhS__"